var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0176 1.66675H3.98424C2.20924 1.66675 0.767578 3.11675 0.767578 4.88341V16.6251C0.767578 18.1251 1.84258 18.7584 3.15924 18.0334L7.22591 15.7751C7.65924 15.5334 8.35924 15.5334 8.78424 15.7751L12.8509 18.0334C14.1676 18.7667 15.2426 18.1334 15.2426 16.6251V4.88341C15.2342 3.11675 13.7926 1.66675 12.0176 1.66675Z",
    stroke: "#020842",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBookmark);
export default __webpack_public_path__ + "static/media/icon_bookmark.cf88d0251edda0266fd3e8e11525f5e3.svg";
export { ForwardRef as ReactComponent };